import { Protocol } from '../../../Typescript/StuartPy/Protocol'
import { useMemo } from 'react'
import { useProtocolGet } from '../../../APIs/Hooks/ProtocolHooks'

export function useFilteredProtocols(enabled: boolean, filter: boolean) {
  const protocolQuery = useProtocolGet('', enabled)
  const filtered: Protocol[] = useMemo(() => {
    const reg = /^\d\d\/\d\d$/
    if (protocolQuery.data) {
      if (filter) {
        return protocolQuery.data.filter((f: { EthicsNumber: string }) =>
          reg.test(f.EthicsNumber),
        )
      } else {
        return protocolQuery.data
      }
    } else {
      return []
    }
  }, [protocolQuery, filter])
  return { ...protocolQuery, data: filtered }
}
